// extracted by mini-css-extract-plugin
export default {"wrapper":"AssistantVolumeSharePieChartTool_wrapper__rb6G2"};